// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2026project/q2/2026sports_dream/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const save = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save`, qsData);
};

const getVoteList = (page: number, search: string, workType: number = 1) => {
  return http.get(
    `${urlPrefix}vote-list&page=${page}&search=${search}&workType=${workType}`,
  );
};

const getDetail = (id: any) => {
  return http.get(`${urlPrefix}detail&id=${id}`);
};

const getUser = (data: any) => {
  const qsData = qs.stringify(data);
  return http.get(`${urlPrefix}user-list&${qsData}`);
};

const ifSave = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}if-save`, qsData);
};

const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

// 新闻
const TEST_API = 'https://t8-testapi-proxy.cqcb.com';
const PRO_API = 'https://t8-api-proxy.cqcb.com';

const getNewsList = (data: any) => {
  let path = '';
  if (process.env.VUE_APP_ENV_NAME === 'development') {
    path = '/wap/api/v1/newsListColumn';
  } else if (process.env.VUE_APP_ENV_NAME === 'TEST') {
    path = TEST_API + '/api/v1/newsListColumn';
  } else if (process.env.VUE_APP_ENV_NAME === 'production') {
    path = PRO_API + '/api/v1/newsListColumn';
  }
  return http.get(path, { params: data });
};

export {
  getBaseInfo,
  getVoteList,
  getDetail,
  save,
  getUser,
  ifSave,
  getRule,
  getNewsList,
};